// Shared Lenis instance holder so nav/CTA can trigger smooth scrollTo.
export const lenisRef = { current: null };
